import {  useIonModal } from '@ionic/react';
import React, { useState } from 'react';
import {Marker} from 'react-leaflet'
import { ParaderoTrenMaya } from '../interfaces';
import L from 'leaflet';
import EstacionTrenModal from './EstacionTrenModal';
import icon from 'leaflet/dist/images/marker-icon.png';

const DefaultIcon = L.icon({
    iconUrl: icon,
    iconSize: [25, 25], // size of the icon
});
L.Marker.prototype.options.icon = DefaultIcon;

const MarkersSitesN = ({sitios,Icon}:{sitios:ParaderoTrenMaya[], Icon: string}) => {
    const [selectedMarker, setSelectedMarker] = useState<ParaderoTrenMaya>();

    const customIcon = L.icon({
        iconUrl: Icon,
        iconSize: [25, 25] // size of the icon
    });

    const [present, dismiss] = useIonModal(EstacionTrenModal,{
        marker: selectedMarker,
        onDismiss: () => dismiss()
      });

    const modalOptions = {
/*        initialBreakpoint: 0.8,
        breakpoints: [0,0.8],
        backdropBreakpoint: 0,*/
        onDidDismiss: ()=>dismiss()
    }

    const markers = sitios.map((item,i) =>(
        <Marker key={i} position={[item.lat,item.lng]} icon={(Icon==="")?(DefaultIcon):(customIcon)}
        eventHandlers={{
            click: () => {
                setSelectedMarker(item);
                present(modalOptions);
            },
          }}>
        </Marker>
    ))
    return <>{markers}</>;
};

export default MarkersSitesN;